
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { AccountingJournalReportFilter } from '../models/accounting-journal-report-filter';

@Injectable({
    providedIn: 'root',
})
export class AccountingJournalService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    private anyToHttpParams(obj: any): HttpParams {
        let params = new HttpParams();
        Object.keys(obj).forEach(function (item) {
            params = params.set(item, obj[item]);
        });
        return params;
    }

    getAccountingJournalByFilters(params: AccountingJournalReportFilter): Observable<any> {
        return this.http.get(`${this.API_URL}AccountingJournal/GetAccountingJournalByFiltersRoute`, { params: this.anyToHttpParams(params), responseType: 'arraybuffer' });
    }


}
